import Vue from 'vue'
import {virtualCategoryInterface} from "../interfaces/virtualCategoryInterface";

export default {
    SET_TRANSLATED_PAGE_ROUTES: (state, translatedLocales) => {
        Vue.set(state, 'translatedCurrentPageRoutes', translatedLocales)
    },

    SET_DEVICE_ORIENTATION: (state, orientation) => {
        Vue.set(state, 'deviceOrientation', orientation)
    },

    SET_IS_DEVICE_MOBILE: (state, isMobile) => {
        Vue.set(state, 'isDeviceMobile', isMobile)
    },

    SET_ROUTES: (state, routes) => {
        Vue.set(state, 'routes', routes)
    },

    SET_MAINTENANCE_MODE: (state, maintenanceMode) => {
        Vue.set(state, 'maintenanceMode', maintenanceMode)
    },

    SET_ERROR_MODE: (state, errorMode) => {
        Vue.set(state, 'errorMode', errorMode)
    },

    SET_OPENED_GAME_WINDOW: (state, gameWindow) => {
        let openedWindows = state.openedGameWindows;

        openedWindows.push(gameWindow)

        Vue.set(state, 'openedGameWindows', openedWindows);
    },

    CLOSE_OPENED_GAME_WINDOWS(state) {
        state.openedGameWindows.forEach(openedWindow => openedWindow && typeof openedWindow.close === 'function' && openedWindow.close());
    },

    SET_REFERRAL_DATA: (state, referralData) => {
        Vue.set(state, 'referralData', referralData)
    },

    SET_REQUEST_IP: (state, ip) => {
        Vue.set(state, 'requestIP', ip)
    },

    SET_REQUEST_USER_AGENT: (state, userAgent) => {
        Vue.set(state, 'requestUserAgent', userAgent)
    },

    SET_LOCALE: (state, locale) => {
        Vue.set(state, 'locale', locale)
    },

    SET_APP_LOCALE: (state, appLocale) => {
        Vue.set(state, 'appLocale', appLocale)
    },

    SET_FALLBACK_LOCALES: (state, locales) => {
        Vue.set(state, 'fallbackLocales', locales)
    },

    SET_USER: (state, user) => {
        Vue.set(state, 'user', user);
    },

    SET_SOCIAL_USER: (state, socialUser) => {
        Vue.set(state, 'socialUser', socialUser);
    },

    UPDATE_USER_PROPERTY: (state, {propertyName, propertyValue}) => {
        if (state.user){
            Vue.set(state.user, propertyName, propertyValue);
        }
    },

    SET_IS_USER_LOGGING_OUT: (state, isLoggingOut) => {
        Vue.set(state, 'isUserLoggingOut', isLoggingOut);
    },

    SET_GUEST_TOKEN: (state, guestToken) => {
        Vue.set(state, 'guestToken', guestToken);
    },

    SET_GUEST_CURRENCY: (state, currency) => {
        Vue.set(state, 'guestCurrency', currency);
    },

    SET_GUEST_COUNTRY: (state, country) => {
        Vue.set(state, 'guestCountry', country);
    },

    SET_WEBP_SUPPORT: (state, isWebpSupported) => {
        Vue.set(state, 'isWebpSupported', isWebpSupported);
    },

    SET_USER_FAVORITE_GAMES_IDS: (state, gamesIds) => {
        Vue.set(state, 'userFavoriteGamesIds', gamesIds);
    },

    SET_USER_BALANCE: (state, userBalance) => {
        Vue.set(state, 'userBalance', userBalance)
    },

    SET_USER_BALANCE_INTERVAL: (state, userBalanceInterval) => {
        Vue.set(state, 'userBalanceInterval', userBalanceInterval)
    },

    SET_USER_ECHO: (state, userEcho) => {
        Vue.set(state, 'userEcho', userEcho)
    },

    ADD_GAME_TO_FAVORITE: (state, game) => {
        let gamesIds = state.userFavoriteGamesIds.filter(id => id);

        gamesIds.push(game.id);

        Vue.set(state, 'userFavoriteGamesIds', gamesIds);

        state.virtualCategoryGames[virtualCategoryInterface.FAVORITE_GAMES] && Vue.set(state.virtualCategoryGames[virtualCategoryInterface.FAVORITE_GAMES], 'mustReload', true);
    },

    REMOVE_GAME_FROM_FAVORITE: (state, game) => {
        let gamesIds = state.userFavoriteGamesIds.filter(gameId => gameId !== game.id);

        Vue.set(state, 'userFavoriteGamesIds', gamesIds);

        state.virtualCategoryGames[virtualCategoryInterface.FAVORITE_GAMES] && Vue.set(state.virtualCategoryGames[virtualCategoryInterface.FAVORITE_GAMES], 'mustReload', true);
    },

    SET_USER_NOTIFICATIONS: (state, notifications) => {
        Vue.set(state, 'userNotifications', notifications)
    },

    SET_PLAYER_TRANSACTIONS: (state, transactions) => {
        Vue.set(state, 'playerTransactions', transactions)
    },

    PUSH_USER_NOTIFICATION: (state, notificationMessage) => {
        let notifications = state.userNotifications || [];

        if (!notifications.find(existingNotification => existingNotification.id === notificationMessage.id)) {
            notifications.unshift(notificationMessage);
        }

        Vue.set(state, 'userNotifications', notifications)
    },

    SET_RTL: (state, isRtl) => {
        Vue.set(state, 'rtl', isRtl)
    },

    SET_APP_CLASS: (state, appClass) => {
        Vue.set(state, 'appClass', appClass)
    },

    SET_TRANSLATION_MESSAGES: (state, messages) => {
        Vue.set(state, 'translationMessages', messages)
    },

    SET_PAGE_DATA: (state, {path, pageData}) => {
        Vue.set(state.pagesData, path, pageData)
    },

    SET_LAYOUT_PARTS: (state, layoutParts) => {
        Vue.set(state, 'layoutParts', layoutParts)
    },

    SET_GAME_PLATFORMS: (state, platformsData) => {
        Vue.set(state, 'gamePlatformsData', platformsData)
    },

    APPEND_GAME_PLATFORMS: (state, platformsData) => {
        let storedPlatforms = state.gamePlatformsData && state.gamePlatformsData.platforms;
        Array.isArray(storedPlatforms) && Vue.set(state.gamePlatformsData, 'platforms', storedPlatforms.concat(platformsData.platforms));

        Vue.set(state.gamePlatformsData, 'hasMorePlatforms', platformsData.hasMorePlatforms);
    },

    SET_GAME_PLATFORM_ITEM: (state, {platform, slug}) => {
        Vue.set(state.gamePlatformItem, slug, platform)
    },

    SET_BASE_DATA_GAME_PLATFORMS: (state, platforms) => {
        Vue.set(state, 'baseDataGamePlatforms', platforms)
    },

    SET_GAME_CATEGORY_ITEM_BY_SLUG: (state, {category, slug}) => {
        Vue.set(state.gamesCategories.slug, slug, category)
    },

    SET_VIRTUAL_GAME_CATEGORY_ITEM: (state, {category, apiId}) => {
        Vue.set(state.gamesCategories.virtual, apiId, category)
    },

    UNSET_USER_GAMES: (state) => {
        Vue.delete(state.virtualCategoryGames, virtualCategoryInterface.FAVORITE_GAMES);
        Vue.delete(state.virtualCategoryGames, virtualCategoryInterface.RECENT_GAMES);
        Vue.delete(state.virtualCategoryGames, virtualCategoryInterface.RECOMMENDED_GAMES);
    },

    SET_CATEGORY_GAMES_BY_ID: (state, {gamesData, categoryId}) => {
        Vue.set(state.categoryGames, categoryId, gamesData)
    },

    SET_VIRTUAL_CATEGORY_GAMES_BY_INTERFACE_ID: (state, {gamesData, virtualCategoryInterfaceId}) => {
        Vue.set(state.virtualCategoryGames, virtualCategoryInterfaceId, gamesData)
    },

    SET_PLATFORM_GAMES_BY_SLUG: (state, {gamesData, platformId}) => {
        Vue.set(state.platformGames, platformId, gamesData)
    },

    SET_WINNER_LIST: (state, list) => {
        Vue.set(state, 'winnerList', list)
    },

    SET_SLIDER_SLIDES: (state, {slides, sliderId}) => {
        Vue.set(state.sliderSlides, sliderId, slides)
    },

    SET_PROMOTIONS_DATA: (state, promotionsData) => {
        Vue.set(state, 'promotionsData', promotionsData)
    },

    SET_SLIDER_PROMOTIONS: (state, promotionsData) => {
        Vue.set(state, 'sliderPromotionsData', promotionsData)
    },

    SET_NEWS_ITEM: (state, {newsItem, newsItemSlug}) => {
        Vue.set(state.newsItem, newsItemSlug, newsItem)
    },

    SET_PAGE_NEWS: (state, {pageNews, page}) => {
        Vue.set(state.pageNews, page, pageNews)
    },

    SET_NEWS_PAGES_COUNT: (state, count) => {
        Vue.set(state, 'newsPagesCount', count)
    },

    SET_SLIDER_NEWS: (state, news) => {
        Vue.set(state, 'sliderNews', news)
    },

    SET_NEWS_TAGS: (state, tags) => {
        Vue.set(state, 'newsTags', tags)
    },

    SET_NEWS_CATEGORIES: (state, categories) => {
        Vue.set(state, 'newsCategories', categories)
    },

    SET_LAUNCHED_GAME: (state, launchedGame) => {
        let launchedGames = state.launchedGames;

        launchedGames.push(launchedGame);

        Vue.set(state, 'launchedGames', launchedGames);
    },

    UPDATE_LAUNCHED_GAME_MODE: (state, {alias, mode}) => {
        let launchedGame = state.launchedGames.find(launchedGame => launchedGame.alias === alias);

        if (launchedGame){
            launchedGame.mode = mode;
        }
    },

    REMOVE_ALL_LAUNCHED_GAMES: (state) => {
        Vue.set(state, 'launchedGames', []);
    },

    REMOVE_LAUNCHED_GAME: (state, removingLaunchedGame) => {
        let launchedGames = state.launchedGames.filter(launchedGame => launchedGame.alias !== removingLaunchedGame.alias);

        Vue.set(state, 'launchedGames', launchedGames.slice(0));
    },

    SET_LAUNCHED_GAME_MOUNTED: (state, {alias, element, iframe, iframeWrapper}) => {
        state.launchedGames.forEach(game => {
            if (game.alias === alias) {
                Vue.set(game, 'mounted', true);
                Vue.set(game, 'element', element);
                Vue.set(game, 'iframe', iframe);
                Vue.set(game, 'iframeWrapper', iframeWrapper);
            }
        })
    },

    SET_LOBBY_BOX: (state, lobbyBox) => {
        Vue.set(state, 'lobbyBox', lobbyBox);
    },

    SET_LAUNCHED_GAME_PROPORTION: (state, {alias, proportion}) => {
        state.launchedGames.forEach(game => {
            if (game.alias === alias) {
                game.proportion = proportion;
            }
        })
    },

    SET_LAUNCHED_GAME_IS_IN_TRAY: (state, alias) => {
        state.launchedGames.forEach(game => {
            if (game.alias === alias) {
                game.isInLobby = true;
                game.isTray = true;
                game.isActive = false;
            }
        })
    },

    SET_LAUNCHED_GAME_IS_IN_LOBBY_BOX: (state, alias) => {
        state.launchedGames.forEach(game => {
            if (game.alias === alias) {
                game.isTray = false;
                game.isActive = true;
            }
        })
    },

    SET_HELP_CATEGORIES: (state, categories) => {
        Vue.set(state, 'helpCategories', categories)
    },

    OPEN_USER_SIDEBAR: (state) => {
        Vue.set(state.sidebar, 'user', true);
    },

    CLOSE_USER_SIDEBAR: (state) => {
        Vue.set(state.sidebar, 'user', false);
    },

    OPEN_MAIN_SIDEBAR: (state) => {
        Vue.set(state.sidebar, 'main', true);
    },

    CLOSE_MAIN_SIDEBAR: (state) => {
        Vue.set(state.sidebar, 'main', false);
    },

    OPEN_LOGIN_DIALOG: (state) => {
        Vue.set(state.signIn, 'loginDialog', true);
    },

    CLOSE_LOGIN_DIALOG: (state) => {
        Vue.set(state.signIn, 'loginDialog', false);
    },

    OPEN_REGISTRATION_DIALOG: (state) => {
        Vue.set(state.signIn, 'registrationDialog', true);
    },

    CLOSE_REGISTRATION_DIALOG: (state) => {
        Vue.set(state.signIn, 'registrationDialog', false);
    },

    OPEN_SOCIAL_REGISTRATION_DIALOG: (state) => {
        Vue.set(state.signIn, 'socialRegistrationDialog', true);
    },

    CLOSE_SOCIAL_REGISTRATION_DIALOG: (state) => {
        Vue.set(state.signIn, 'socialRegistrationDialog', false);
    },

    OPEN_FORGOT_PASSWORD_DIALOG: (state) => {
        Vue.set(state.signIn, 'forgotPasswordDialog', true);
    },

    CLOSE_FORGOT_PASSWORD_DIALOG: (state) => {
        Vue.set(state.signIn, 'forgotPasswordDialog', false);
    },

    OPEN_CHECK_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'checkConfirmSignupDialog', true);
    },

    CLOSE_CHECK_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'checkConfirmSignupDialog', false);
    },

    OPEN_SUCCESS_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'successConfirmSignupDialog', true);
    },

    CLOSE_SUCCESS_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'successConfirmSignupDialog', false);
    },

    OPEN_FAILED_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'failedConfirmSignupDialog', true);
    },

    CLOSE_FAILED_CONFIRM_SIGNUP_DIALOG: (state) => {
        Vue.set(state.signIn, 'failedConfirmSignupDialog', false);
    },

    OPEN_DEPOSIT_DIALOG: (state) => {
        Vue.set(state.payment, 'depositDialog', true);
    },

    CLOSE_DEPOSIT_DIALOG: (state) => {
        Vue.set(state.payment, 'depositDialog', false);
    },

    OPEN_WITHDRAW_DIALOG: (state) => {
        Vue.set(state.payment, 'withdrawDialog', true);
    },

    CLOSE_WITHDRAW_DIALOG: (state) => {
        Vue.set(state.payment, 'withdrawDialog', false);
    },

    CLOSE_ALL_SIGN_IN_DIALOGS: (state) => {
        Object.keys(state.signIn).forEach(key => Vue.set(state.signIn, key, false));
    },

    SET_INTENDED_URL: (state, url) => {
        Vue.set(state, 'intendedUrl', url);
    },

    CLEAR_INTENDED_URL: (state) => {
        Vue.set(state, 'intendedUrl', null);
    },

    OPEN_PROMOTION_DIALOG: (state) => {
        Vue.set(state.dialogs, 'promotion', true);
    },

    CLOSE_PROMOTION_DIALOG: (state) => {
        Vue.set(state.dialogs, 'promotion', false);
    },

    OPEN_LOTTERY_AWARD_DIALOG: (state) => {
        Vue.set(state.dialogs, 'lotteryAward', true);
    },

    CLOSE_LOTTERY_AWARD_DIALOG: (state) => {
        Vue.set(state.dialogs, 'lotteryAward', false);
    },

    OPEN_LOTTERY_WINNERS_DIALOG: (state) => {
        Vue.set(state.dialogs, 'lotteryWinners', true);
    },

    CLOSE_LOTTERY_WINNERS_DIALOG: (state) => {
        Vue.set(state.dialogs, 'lotteryWinners', false);
    },

    OPEN_GAME_MOBILE_DIALOG: (state) => {
        Vue.set(state.dialogs, 'gameMobileDialog', true);
    },

    CLOSE_GAME_MOBILE_DIALOG: (state) => {
        Vue.set(state.dialogs, 'gameMobileDialog', false);
    },

    OPEN_SEARCH_DIALOG: (state) => {
        Vue.set(state.dialogs, 'searchDialog', true);
    },

    CLOSE_SEARCH_DIALOG: (state) => {
        Vue.set(state.dialogs, 'searchDialog', false);
    },

    OPEN_FAVORITE_DIALOG: (state) => {
        Vue.set(state.dialogs, 'favoriteDialog', true);
    },

    CLOSE_FAVORITE_DIALOG: (state) => {
        Vue.set(state.dialogs, 'favoriteDialog', false);
    },

    OPEN_POPUP_NOTIFICATIONS: (state) => {
        Vue.set(state.dialogs, 'notificationsPopup', true);
    },

    CLOSE_POPUP_NOTIFICATIONS: (state) => {
        Vue.set(state.dialogs, 'notificationsPopup', false);
    },

    OPEN_SUPPORT_DIALOG: (state) => {
        Vue.set(state.dialogs, 'supportDialog', true);
    },

    CLOSE_SUPPORT_DIALOG: (state) => {
        Vue.set(state.dialogs, 'supportDialog', false);
    },

    SET_CURRENT_RECOMMENDED_GAME_DATA: (state, data) => {
        Vue.set(state, 'currentRecommendedGameData', data);
    },

    SET_SEARCH_GAMES_DATA: (state, data) => {
        Vue.set(state, 'searchGamesData', data);
    },

    SET_LOTTERY_CURRENT_DATA: (state, data) => {
        Vue.set(state.lotteryData, 'current', data);
    },

    SET_LOTTERY_FUTURE_DATA: (state, data) => {
        Vue.set(state.lotteryData, 'future', data);
    },

    SET_LOTTERY_PAST_DATA: (state, data) => {
        Vue.set(state.lotteryData, 'past', data);
    },

    SET_LOTTERY_TICKETS_DATA: (state, data) => {
        Vue.set(state.lotteryData, 'tickets', data);
    },

    SET_LOTTERY_WINNERS_DATA: (state, data) => {
        Vue.set(state.lotteryData, 'winners', data);
    },

    SET_FORTUNE_WHEELS: (state, data) => {
        Vue.set(state, 'fortuneWheels', data);
    },

    APPEND_FORTUNE_WHEEL: (state, fortuneWheel) => {
        let storedFortuneWheels = state.fortuneWheels;

        let storedFortuneWheel = storedFortuneWheels.find(storedFortuneWheel => storedFortuneWheel.id === fortuneWheel.id);

        if (storedFortuneWheel) {
            let storedFortuneWheelSpins = storedFortuneWheel.fortuneWheelSpins;

            fortuneWheel.fortuneWheelSpins.forEach(fortuneWheelSpin => {
                let storedFortuneWheelSpin = storedFortuneWheelSpins.find(storedFortuneWheelSpin => storedFortuneWheelSpin.id === fortuneWheelSpin.id);

                if (!storedFortuneWheelSpin) {
                    storedFortuneWheelSpins.push(fortuneWheelSpin);
                }
            });
        } else {
            storedFortuneWheels.push(fortuneWheel);
        }

        Vue.set(state, 'fortuneWheels', storedFortuneWheels.slice(0));
    },

    REMOVE_EXECUTED_SPIN: (state, {fortuneWheelId, fortuneWheelSpinId}) => {
        let storedFortuneWheels = state.fortuneWheels;

        let storedFortuneWheel = storedFortuneWheels.find(storedFortuneWheel => storedFortuneWheel.id === fortuneWheelId);

        if (storedFortuneWheel) {
            let storedFortuneWheelSpins = storedFortuneWheel.fortuneWheelSpins;

            let spinIndex = storedFortuneWheelSpins.findIndex(storedFortuneWheelSpin => storedFortuneWheelSpin.id === fortuneWheelSpinId);

            storedFortuneWheelSpins.splice(spinIndex, 1);

            storedFortuneWheel.fortuneWheelSpins = storedFortuneWheelSpins;
        }

        Vue.set(state, 'fortuneWheels', storedFortuneWheels.slice(0));
    },

    OPEN_FORTUNE_WHEEL: (state) => {
        Vue.set(state.dialogs, 'fortuneWheel', true);
    },

    CLOSE_FORTUNE_WHEEL: (state) => {
        Vue.set(state.dialogs, 'fortuneWheel', false);
    },

    SET_FORTUNE_WHEEL_CAPTCHA_PASSED: (state, isPassed) => {
        Vue.set(state, 'isFortuneWheelCaptchaPassed', isPassed);
    },

    SET_TOURNAMENT: (state, {tournament, slug}) => {
        Vue.set(state.tournament.item, slug, tournament);
    },

    SET_TOURNAMENTS: (state, tournaments) => {
        Vue.set(state.tournament, 'list', tournaments);
    },

    // SET_MY_TOURNAMENT: (state, data) => {
    //     Vue.set(state.tournament, 'my', data);
    // },

    SET_LOBBY_MENU_POSITION: (state, {axis, pos}) => {
        Vue.set(state.lobbyMenuPosition, axis, pos);
    },

    SET_VIP_LEVELS: (state, data) => {
        Vue.set(state, 'vipLevels', data);
    },
}
